<div class="nuevo-catalogo-container" *ngIf="user$ | async as user">
  <p class="heading-catalogo !normal-case">USUARIOS</p>
  @if (user.rol==4) {
  <button
    (click)="nuevo = true; ocultarBotones(false)"
    mat-mini-fab
    aria-label="Agregar nuevo tipo"
    color="primary">
    <mat-icon>add</mat-icon>
  </button>
  }@else {
  <p></p>
  }
</div>

<div *ngIf="admonCatUsuariosStatus$ | async as usuariosStatus">
  <mat-card-content
    class="nuevo-catalogo-card"
    *ngIf="usuariosStatus.mostrarNuevo">
    <mat-card class="nuevo-catalogo-mat-card nuevo-catalogo-mat-card-user">
      <form [formGroup]="nuevoRegistro">
        <section class="nuevo-catalogo-form" style="padding-top: 1rem">
          <p class="heading-3">Agregar usuario</p>
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Nombre</mat-label>
            <input
              formControlName="nombre"
              name="nombre"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="75"
              matInput
              placeholder="" />
            <mat-hint align="end"
              >{{ nuevoRegistro.get("nombre")?.value.length }} / 75</mat-hint
            >
            @if (nuevoRegistro.get('nombre')?.invalid &&
            nuevoRegistro.get('nombre')?.touched &&
            !nuevoRegistro.get('nombre')?.hasError('nombreUsuario')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if (nuevoRegistro.get('nombre')?.invalid &&
            nuevoRegistro.get('nombre')?.touched &&
            nuevoRegistro.get('nombre')?.hasError('nombreUsuario')) {
            <mat-error>Solo se permiten caracteres alfabéticos.</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Correo electrónico</mat-label>
            <input
              formControlName="mail"
              name="mail"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="150"
              matInput
              placeholder="" />

            @if (nuevoRegistro.get('mail')?.invalid &&
            nuevoRegistro.get('mail')?.touched&&
            !nuevoRegistro.get('mail')?.hasError('invalidEmail')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if (nuevoRegistro.get('mail')?.invalid &&
            nuevoRegistro.get('mail')?.touched &&
            nuevoRegistro.get('mail')?.hasError('invalidEmail')) {
            <mat-error>{{
              "El correo electrónico proporcionado es incorrecto, por favor ingréselo en el siguiente formato: usuario/a@dominio Ej: ejemplo@gnp.com.mx"
            }}</mat-error>
            }
          </mat-form-field>
          <p class="subtitle-catalogos !mb-0">Seleccione un rol:</p>
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="radio-group mt-2 mb-2"
            formControlName="rol"
            name="rol">
            @for (rol of catRoles; track rol) {
            <mat-radio-button
              [color]="rol.rol == 4 ? 'primary' : 'warn'"
              class="rol-radio-button"
              [value]="rol.rol"
              >{{ rol.label }}</mat-radio-button
            >
            }
          </mat-radio-group>
          <section
            *ngIf="
              nuevoRegistro.get('rol') && nuevoRegistro.get('rol')?.value == 1
            ">
            <p class="subtitle-catalogos !mb-0">Envío a AB</p>
            <mat-checkbox
              color="warn"
              class="presentar-usuario-check !mb-3"
              type="checkbox"
              formControlName="formaEnvio"
              name="formaEnvio"
              >Presentar usuario en catálogo</mat-checkbox
            >
            <!-- <div class="container-catalogos-flex">
              <input
                type="checkbox"
                formControlName="formaEnvio"
                name="formaEnvio"
                class="nuevo-catalogo-check" />
              <span class="text-cataloogos">Presentar usuario en catálogo</span>
            </div> -->
          </section>
          <p class="subtitle-catalogos">Permisos</p>
          <div class="nuevo-catalogo-permisos">
            <mat-form-field class="mat-form-field-combo">
              <mat-label>Tema</mat-label>
              <mat-select formControlName="tema" name="tema">
                @for (permiso of catTemas; track permiso) {
                <mat-option [value]="permiso">{{
                  permiso.descripcion
                }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="mat-form-field-combo">
              <mat-label>Acción</mat-label>
              <mat-select formControlName="accion" name="accion">
                @for (accion of catAcciones; track accion) {
                <mat-option [value]="accion">{{ accion.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <section class="container-catalogos-flex">
              <mat-checkbox
                color="warn"
                class="!mb-3"
                type="checkbox"
                formControlName="notificacion"
                value="notificacion"
                >Notificaciones</mat-checkbox
              >
              <!-- <input
                formControlName="notificacion"
                value="notificacion"
                class="nuevo-catalogo-check"
                type="checkbox" />
              <span class="text-cataloogos">Notificaciones</span> -->
            </section>
            <button
              (click)="nuevoPermiso()"
              mat-mini-fab
              aria-label="Agregar nuevo tipo"
              color="primary">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </section>
        <section class="nuevo-catalogo-form-chips" style="padding: 1rem">
          <mat-chip-grid #chipGrid aria-label="Fruit selection">
            @for (permiso of permisosSeleccionados; track permiso) {
            <mat-chip-row (removed)="removePermiso(permiso)">
              {{ permiso.descChip }}
              <button
                matChipRemove
                [attr.aria-label]="'remove ' + permiso.descChip">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
            }
          </mat-chip-grid>
          <hr />
        </section>
      </form>
      <mat-card-actions align="end" class="nuevo-catalogo-actions">
        <button
          class="uppercase-button"
          mat-raised-button
          (click)="hideNuevo()">
          Cancelar
        </button>
        <button
          class="uppercase-button"
          [disabled]="validateFilds()"
          mat-raised-button
          (click)="guardarRegistro()"
          color="primary">
          Guardar
        </button>
      </mat-card-actions>
    </mat-card>
  </mat-card-content>
</div>
